import { IsMobileService } from '@shared/services/is-mobile.service';
import { Component, inject, Input } from '@angular/core';

@Component({
  selector: 'sigecom-list-title',
  template: `
    <div class="text-lg font-bold text-[#333333]"
      [ngClass]="{'w-full': (isMobile$ | async)}"
    >
      {{ text }}
    </div>
  `,
})
export class ListTitleComponent {
  @Input() text: string = '';
  #isMobileService = inject(IsMobileService);
  isMobile$ = this.#isMobileService.isMobile$;
}
